<template>
  <div class="msg_container">
    <div class="msg_top">
      <div>消息详情</div>
      <div class="back" @click="goBack">&lt;&lt; 返回</div>
    </div>
    <!-- 大标题 -->
    <div class="msg_title">
      <div>{{ msgDetail.title }}</div>
      <div>{{ (msgDetail.addtime * 1000) | dateFormat }}</div>
    </div>
    <!-- 消息内容 -->
    <div class="msg_desc" v-html="msgDetail.content"></div>
    <!-- <div class="msg_desc">{{msgDetail.content}}</div> -->
    <!-- <div class="msg_desc">
      <pre id="msg" style="white-space: pre-line">{{ msgDetail.content }}</pre>
    </div> -->
  </div>
</template>
<script>
import { getMsgDetail } from "../../assets/js/api.js";
export default {
  data() {
    return {
      msgDetail: "",
    };
  },
  mounted() {
    // console.log(this.$route.query);
    this.id = this.$route.query.id;
    this.getMsgDetail();
  },
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    getMsgDetail() {
      getMsgDetail(window.localStorage.getItem("siteId"),this.id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.msgDetail = res.data;
          console.log(this.msgDetail)
          // this.msgDetail.content = this.msgDetail.content.replace(
          //   /(&nbsp;)/g,
          //   ""
          // );
          // this.msgDetail.content = this.msgDetail.content
          //   .replace(/\r\n/g, "<br/>")
          //   .replace(/\n/g, "<br/>")
          //   .replace(/\s/g, "&nbsp;");
          // console.log(this.msgDetail.content);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.msg_container {
  width: 1200px;
  margin: 0 auto;
  margin-top: 110px;
  margin-bottom: 140px;
  .msg_top {
    width: 100%;
    height: 35px;
    border-left: 5px solid #029aff;
    padding-left: 15px;
    box-sizing: border-box;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #343434;
    .back {
      width: 70px;
      height: 30px;
      border: 1px solid #bcbcbc;
      border-radius: 4px;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }
  }
  .msg_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    background-color: #f5f5f5;
    padding: 0 20px;
    box-sizing: border-box;
    color: #343434;
    font-size: 18px;
    margin: 40px 0;
    div:nth-child(2) {
      font-size: 14px;
    }
  }
  .msg_desc {
    font-size: 16px;
    line-height: 1.8;
  }
}
</style>
